<template>
<div>
  <loading v-if="items == null || loading"></loading>

  <div v-else>
    <v-row>
      <v-col sm="6" :key="item.uuid" v-for="item in items">
        <saved-search :item="item" @edit="onEdit" @remove="onRemove"></saved-search>
      </v-col>
    </v-row>
  </div>

  <div class="text-center mt-12">
    <v-btn color="primary" @click="onCreate" large>{{ $t("Neues Suchprofil erstellen") }}</v-btn>
  </div>

  <confirm v-model="confirm" title="Suchprofil löschen">
    <template>
      {{ $t("Möchten Sie Ihr Suchprofil wirklich löschen?") }}
    </template>
  </confirm>
</div>
</template>

<script>
import SavedSearch from "./SavedSearch";
import SavedSearchEdit from "./SavedSearchEdit";
import SavedSearchCreate from "./SavedSearchCreate";
import Confirm from "../utils/Confirm";
import Loading from "../utils/Loading";

export default {
  name: "SavedSearchList",

  components: {
    SavedSearch,
    Confirm,
    Loading
  },

  data() {
    return {
      confirm: false,
      wizard: false,
      edit: null,
      error: false,
      loading: false
    }
  },

  computed: {
    items() {
      return this.$store.state.contact.savedSearchList;
    }
  },

  created() {
    this.$store.dispatch("contact/loadSavedSearchList");
  },

  methods: {
    onEdit(savedSearch) {
      this.$store.commit("userDialog", { component: SavedSearchEdit, props: { savedSearch } });
    },

    onCreate() {
      this.$store.commit("userDialog", { component: SavedSearchCreate });
    },

    onRemove(savedSearch) {
      this.confirm = {
        ok: () => {
          this.loading = true;
          this.$store.dispatch("contact/deleteSavedSearch", savedSearch).then(() => {
          }).finally(() => {
            this.loading = false;
          });
        }
      };
    }
  }
};
</script>
